require('./bootstrap');
require('croppie');
import Utilities from './utilities';
require('livewire-sortable')
import Alpine from 'alpinejs'
 
window.Alpine = Alpine
 
Alpine.start()

window.Utilities = Utilities;




// function copyTextToClipboard($el) {
//     /* Get the text field */
//     var copyText = $el;
  
//     /* Select the text field */
//     copyText.select();
//     copyText.setSelectionRange(0, 99999); /*For mobile devices*/
  
//     /* Copy the text inside the text field */
//     document.execCommand("copy");
// }

// window.debounce = function(func, wait, immediate) {
// 	var timeout;
// 	return function() {
// 		var context = this, args = arguments;
// 		var later = function() {
// 			timeout = null;
// 			if (!immediate) func.apply(context, args);
// 		};
// 		var callNow = immediate && !timeout;
// 		clearTimeout(timeout);
// 		timeout = setTimeout(later, wait);
// 		if (callNow) func.apply(context, args);
// 	};
// };